export default __webpack_public_path__ + "static/media/noPaymentRequiredIcon.3d8dde72.svg";